import { Box, IconButton, Stack } from "@mui/material";
import { Eye } from "iconsax-react";
import { Link } from "react-router-dom";

interface IDeleteActionProps {
  link: string;
  disabled?: boolean;
}

export default function ViewActionLink({
  link,
  disabled,
}: Readonly<IDeleteActionProps>) {
  return (
    <Stack display={disabled ? "none" : "flex"} component={Link} to={link}>
      <IconButton
        sx={{
          padding: "4px",
          borderRadius: "50%",
          width: "fit-content",
          cursor: "pointer",
          mx: "auto",

          "&:hover": {
            color: (theme) => theme.palette.others.active,
            // backgroundColor: (theme) => theme.palette.others.activeBg,
          },
        }}
      >
        <Eye
          size="18"
          //  color="#FF8A65"
        />
      </IconButton>
    </Stack>
  );
}
